import React, { useState, useEffect } from 'react';
import './Support.css';
import GetSupport from './components/GetSupport';
import NetworkStatus from './components/NetworkStatus';
import SupportTickets from './components/SupportTickets';
import { useAuth } from '../../../contexts/AuthContext';
import axios from 'axios';
import { getScenarioContent, getTemplatePrefix } from '../Constants/paymentScenarios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const defaultToggles = {
  networkStatus: true,
  servicelevel: true,
  createTicket: true,
  usageAnalysis: true,
  upgrade: true,
};

function safeParseTemplate(template) {
  try {
    let parsed = JSON.parse(template);
    if (typeof parsed === 'string') parsed = JSON.parse(parsed);
    return parsed;
  } catch (err) {
    console.error('Error parsing template:', err);
    return {};
  }
}

const Support = ({ activeData }) => {
  const { token } = useAuth();
  
  const paymentScenario = activeData || null;
  console.log('Support - Received paymentScenario:', paymentScenario);

  const scenarioContent = getScenarioContent(paymentScenario);
  const scenarioPrefix = getTemplatePrefix(paymentScenario);

  const template_name = scenarioPrefix === 'current-payment' 
    ? 'gardenwall-support' 
    : `gardenwall-support-${scenarioPrefix}`;
    
  console.log('Support Template name:', template_name);

  const [templates, setTemplates] = useState([]);
  const [toggles, setToggles] = useState(defaultToggles);

  // Fetch templates function
  const fetchTemplates = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/templates/list`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `${token}`,
          },
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    }
  };

  // Load templates on mount
  useEffect(() => {
    const loadTemplates = async () => {
      const fetchedTemplates = await fetchTemplates();
      setTemplates(fetchedTemplates || []);

      const specificTemplate = fetchedTemplates?.find(
        (template) => template.template_name === template_name
      );
      
      if (specificTemplate) {
        const template_data = safeParseTemplate(specificTemplate.template);
        if (template_data.toggles) {
          setToggles({ ...defaultToggles, ...template_data.toggles });
        }
      }
    };
    loadTemplates();
  }, [template_name, token]);

  // Save data function
  const saveData = async (newToggles) => {
    const formData = new FormData();
    formData.append('template_name', template_name);
    formData.append(
      'template',
      JSON.stringify({
        toggles: newToggles,
        scenarioData: paymentScenario
      })
    );
    
    console.log('Support - Saving template with name:', template_name);

    const urlBase = `${process.env.REACT_APP_BASE_URL}/templates`;
    let url = `${urlBase}/create`;
    let method = 'post';

    const specificTemplate = templates.find(
      (template) => template.template_name === template_name
    );
    if (specificTemplate?.id) {
      url = `${urlBase}/update/${specificTemplate.id}`;
      method = 'put';
    }

    try {
      const response = await axios({
        method: method,
        url: url,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${token}`,
        },
      });
      console.log('Support Response Data:', response.data);
    } catch (error) {
      console.error('Error saving support template:', error);
    }
  };

  // Toggle handler
  const handleToggle = (section) => {
    const updatedToggles = { ...toggles, [section]: !toggles[section] };
    setToggles(updatedToggles);
    saveData(updatedToggles);
  };

  // Extract support block states from toggles
  const supportBlockStates = {
    createTicket: toggles.createTicket,
    usageAnalysis: toggles.usageAnalysis,
    upgrade: toggles.upgrade,
  };

  return (
    <div className="support">
      <div className="support-main">
        <h1 className="support-header">
          Support – <span className={scenarioContent.headerClass}>{scenarioContent.headerStatus}</span>
        </h1>

        <div className="support-grid">
          <div className={`card col-6`}>
            <GetSupport
              scenarioData={paymentScenario}
              supportBlocksEnabled={supportBlockStates}
              onSupportBlockStatesChange={handleToggle}
            />
          </div>

          <div className={`card col-6 ${!toggles.networkStatus ? 'card-disabled' : ''}`}>
            <div className="card-header">
              Network Status
              <div className="custom-toggle" onClick={() => handleToggle('networkStatus')}>
                <input type="checkbox" checked={toggles.networkStatus} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <NetworkStatus 
              scenarioData={paymentScenario}
            />
          </div>

          <div className={`card col-6 ${!toggles.servicelevel ? 'card-disabled' : ''}`}>
            <div className="card-header">
              Support Tickets
              <div className="custom-toggle" onClick={() => handleToggle('servicelevel')}>
                <input type="checkbox" checked={toggles.servicelevel} readOnly />
                <span className="toggle-slider"></span>
              </div>
            </div>
            <SupportTickets 
              scenarioData={paymentScenario}
            />
          </div>
        </div>

        <ToastContainer position="top-right" newestOnTop />
      </div>
    </div>
  );
};

export default Support;

